import React from "react";
import {Control, Controller, FieldPath, FieldValues} from "react-hook-form";
import {CommonFieldProps} from "@components/Form/index";

interface TextareaFieldProps<T extends FieldValues> extends CommonFieldProps<T> {
    control: Control<T>;
    name: FieldPath<T>;
    label: string;
    disabled?: boolean;
    error?: string;
    rows?: number;
}

export function TextareaField<T extends FieldValues>(props: TextareaFieldProps<T>) {

    const {control, name, label, disabled, error, rows = 4, className} = props;
    const [focused, setFocused] = React.useState(false);

    return (
        <div className={`form__field ${className ?? ""}`}>
            <div className="form__field__input">
                <Controller
                    control={control}
                    name={name}
                    render={({ field, fieldState }) => {
                        const value = String(field.value ?? "");
                        const hasValue = value.length > 0;
                        const errorMsg = error || fieldState.error?.message;
                        const invalid = !!errorMsg || fieldState.invalid;

                        return (
                            <div
                                className={[
                                    "ds-input",
                                    "ds-input--textarea",
                                    focused ? "ds-input--active" : "",
                                    disabled ? "ds-input--disabled" : "",
                                    hasValue ? "ds-input--filled" : "",
                                    invalid ? "ds-input--error" : "",
                                ]
                                    .filter(Boolean)
                                    .join(" ")}
                            >
                                <label className="ds-input__label" htmlFor={field.name}>
                                    {label}
                                </label>

                                <textarea
                                    {...field}
                                    id={field.name}
                                    value={value}
                                    rows={rows}
                                    className="ds-input__control ds-input__control--textarea"
                                    disabled={disabled}
                                    onFocus={() => setFocused(true)}
                                    onBlur={() => {
                                        setFocused(false);
                                        field.onBlur();
                                    }}
                                />
                            </div>
                        );
                    }}
                />
            </div>

            {!!error && <div className="form__field__error">{error}</div>}
        </div>
    );
}
